import { Menu } from '../constants/actionTypes'
const { TOGGLE_MENU } = Menu
export const toggleMenu = payload => ({
  type: TOGGLE_MENU,
  payload,
})
